import { randomUUID } from '@/src/common/utils/randomUUID'
import { useMemo, type ComponentProps } from 'react'
import Svg, { Path, Filter, FeColorMatrix, Defs } from 'react-native-svg'

export function PointsTransfer(props: ComponentProps<typeof Svg> & { grayscale?: boolean }) {
  const uniqueId = useMemo(() => randomUUID(), [])
  const filterId = `grayscale-${uniqueId}`
  const grayscale = props.grayscale ? `url(#${filterId})` : undefined

  return (
    <Svg width={63} height={63} viewBox="0 0 63 63" fill="none" {...props}>
      <Defs>
        <Filter id={filterId}>
          <FeColorMatrix type="saturate" values="0" />
        </Filter>
      </Defs>
      <Path
        d="M0 8a8 8 0 018-8h47a8 8 0 018 8v47a8 8 0 01-8 8H8a8 8 0 01-8-8V8z"
        fill="#C6FFF5"
        filter={grayscale}
      />
      <Path fill="#00DFC9" d="M20 23H26V42H20z" filter={grayscale} />
      <Path fill="#00DFC9" d="M38 23H44V42H38z" filter={grayscale} />
      <Path
        d="M22.125 42c-.829 0-1.624-.286-2.21-.795-.586-.509-.915-1.2-.915-1.92v-13.57c0-.72.33-1.411.915-1.92.586-.509 1.381-.795 2.21-.795h18.75c.829 0 1.624.286 2.21.795.586.509.915 1.2.915 1.92v13.57c0 .72-.33 1.411-.915 1.92-.586.509-1.381.795-2.21.795 Z"
        stroke="#223843"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
        filter={grayscale}
      />
      <Path
        d="M26.167 41.5V20.833a2.667 2.667 0 012.666-2.666h5.334a2.667 2.667 0 012.666 2.666V41.5"
        stroke="#223843"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
        filter={grayscale}
      />
    </Svg>
  )
}

export default PointsTransfer
